import { AUTO_SUGGEST_URL } from './../../config/apiPoints';
import { searchFetch } from './config';

export const searchWidgetLocationSearchURL = (params) => {
  const url = `${__ENV_CONFIG__.__AUTO_SUGGEST__}${AUTO_SUGGEST_URL}&query=${params}&limit=${searchFetch.itemCountToFetch}`;
  return url;
};
